
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skintone_analyzer",
      function () {
        return require("private-next-pages/skintone_analyzer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skintone_analyzer"])
      });
    }
  